SupportEmailFormIntlVerticalView = require('../../email_form/INTL/vertical_view')
SharedFooterIntlPhoneNumberView = require('../../../../../shared/frontend/views/footer/INTL/phone_number_view')
SupportV1StepThreeBaseView = require('../v1_base_view')
EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view')
SupportEmailFormIntlV2FlexibleContactChannelsView = require('../../email_form/INTL/v2_flexible_contact_channels')
EmailFormLiveChatClickView = require('../../email_form/common/live_chat_click_view')
EmailFormCallClickView = require('../../email_form/common/call_click_view')
EmailFormV2FlexibleContactChannelsTextView = require('../../email_form/common/v2_flexible_contact_channel_text_view')

class SupportVerticalINTLStepThreeView extends SupportV1StepThreeBaseView
  className: 'vertical step-three'

  getEmailFormView: (options) ->
     new SupportEmailFormIntlVerticalView(options)

  renderPhoneNumberView: ->
    propagateEventBeforeReplacingElements( () =>
      @callClickHandler()
    )

  callClickHandler: ->
    unless @callClickView
      @callClickView = new EmailFormCallClickView({
        phoneNumberView: @getPhoneNumberView(this)
        contactChannelTextView: @getContactChannelTextView(this)
      })
      @callClickView.render()
      @$el.html(@callClickView.el)
      @callClickView.postRenderhandler()

  getContactChannelTextView: (stepThreeView)->
    new EmailFormV2FlexibleContactChannelsTextView({
      mainView: stepThreeView
      emailFormModel: stepThreeView.emailFormModel
      showOnlyFlexibleText: true
    })

  getPhoneNumberView: (stepThreeView) ->
    new SharedFooterIntlPhoneNumberView({
      emailFormModel: stepThreeView.emailFormModel
      renderPopup: false
    })

  shouldShowContactChannelView: ()->
    not window.priorityViewsEnabled()

  configureContactChannelView: (options) ->
    new SupportEmailFormIntlV2FlexibleContactChannelsView(options)

  renderEmailForm: ->
    SupportV1StepThreeBaseView::renderEmailForm.apply(this, arguments)

  renderProgressBar: ->

  renderChatClickView: () ->
    if @isFlexibleContactEnabled()
      liveChatClickView = new EmailFormLiveChatClickView()
      liveChatClickView.render()
      @$el.html liveChatClickView.el

module.exports = SupportVerticalINTLStepThreeView
